import React, { useState, useEffect } from 'react';
import { Container } from 'reactstrap';
import axios from '../../../axios-base';
import Page from '../../../components/Page/Page';

function JuryTermsPage() {
    const [pageData, setPageData] = useState(null);

    useEffect(() => {
        axios
            .get('/jury/rahmenbedingungen')
            .then((res) => setPageData(res.data))
            .catch((err) => console.error('Failed to load jury terms page:', err));
    }, []);

    if (!pageData) return null;

    return (
        <Container className="my-4">
            <Page pageTitle={pageData.title} pageBody={pageData.body} survey={pageData.survey} />
        </Container>
    );
}

export default JuryTermsPage;
